module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "poem3",
    attrs: {
      "id": "chap2"
    }
  }, [_vm._v("To remain whole, be twisted.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("To become straight, let yourself be bent.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("To become full, be hollow.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("Be tattered, that you may be renewed.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("Those that have little, may get more,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("Those that have much, are but perplexed.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("The Sage does not show himself, therefore he is seen everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("He does not define himself, therefore he is distinct.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("He does not boast of what he will do, therefore he succeeds.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("He is not proud of his work, and therefore it endures.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("He does not contend,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("And for that very reason no one under heaven can contend with him.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("—Tao Te Ching")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("For by grace are ye saved through faith, and that not of yourselves. It is the gift of God. Not of works, lest any man should boast.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("—"), _c('i', [_vm._v("Ephesians 2")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f098bb7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9chap2.vue
// module id = 87
// module chunks = 0